import { createFileRoute } from '@tanstack/react-router'
import SummaryAdmin from '@/components/reports-route/summary/summary-admin'
import SummaryPersonal from '@/components/reports-route/summary/summary-personal'
import { getUser } from '@/utils/auth'
import { UserRole } from '@/constants/user.js'

export const Route = createFileRoute('/_auth/report/summary')({
  component: Summary,
})

function Summary() {
  const user = getUser()
  if (user?.role !== UserRole.AGENT) {
    return <SummaryAdmin />
  } else {
    return <SummaryPersonal />
  }
}
